import React, { useState } from "react";
import axios from "axios";


const usePasswdSetting = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {
    const [data, setData] = useState([])
    const getPasswdSettingData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get('/organization_structure/api/passwd_setting', {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data?.data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }

    // const postPasswdSettingData= (data) => {
    //     onBefore({
    //         axiosMode: "post"
    //     })
    //     axios.post('/organization_structure/api/department',
    //         data
    //     )
    //         .then((response) => {
    //             let responseData = response.data
    //             let status = responseData?.status
    //             if (status === "fail") {
    //                 onFinish(
    //                     {
    //                         axiosMode: "post",
    //                         status: "error"
    //                     }
    //                 )
    //             }
    //             else {
    //                 onFinish(
    //                     {
    //                         axiosMode: "post",
    //                         status: "success"
    //                     }
    //                 )
    //             }
    //         })
    //         .catch(() => {
    //             onFinish(
    //                 {
    //                     axiosMode: "post",
    //                     status: "error"
    //                 }
    //             )
    //         })
    // }

    const patchPasswdSettingData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        data = [data]
        axios.patch('/organization_structure/api/passwd_setting',
                data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }

    // const deletePasswdSettingData = (data) => {
    //     onBefore({
    //         axiosMode: "delete"
    //     })
    //     axios.delete('/organization_structure/api/department',
    //         {
    //             data
    //         }
    //     )
    //         .then((response) => {
    //             let responseData = response.data
    //             let status = responseData?.status
    //             if (status === "fail") {
    //                 onFinish(
    //                     {
    //                         axiosMode: "delete",
    //                         status: "error"
    //                     }
    //                 )
    //             }
    //             else {
    //                 onFinish(
    //                     {
    //                         axiosMode: "delete",
    //                         status: "success"
    //                     }
    //                 )
    //             }
    //         })
    //         .catch(() => {
    //             onFinish(
    //                 {
    //                     axiosMode: "delete",
    //                     status: "error"
    //                 }
    //             )
    //         })
    // }
    return {
        PasswdSettingData: data,
        getPasswdSettingData,
        // postPasswdSettingData,
        patchPasswdSettingData,
        // deletePasswdSettingData,
    }
}
export { usePasswdSetting }
